export default __webpack_public_path__ + "static/media/typeCrane.84bbb2c5.84bbb2c5.svg";